import { useSelector } from "react-redux";
import "../style/calendar/Events.scss";

const Events = () => {
  // const [eventList,setEventList] = useState([
  //   {
  //     id:1,
  //     title:"آزمون فلسفه زندگی",
  //     time:'11:00'
  //   },
  //   {
  //     id:2,
  //     title:"آزمون موسیقی شناسی",
  //     time:'18:00'
  //   },
  // ])

  const state = useSelector((state) => state.default);
  console.log(state.CalendarSelectedDay);
  // const [eventList,setEventList] = useState(state.CalendarEventList);
  console.log(state.CalendarEventList);
  return (
    <div className="Events">
      <div className="Events-title-box">
        <div className="Events-title-box-date">
          {state.CalendarSelectedDay.year}/{state.CalendarSelectedDay.month}/
          {state.CalendarSelectedDay.day}
        </div>
        <div className="Events-title-box-text">رویدادها</div>
      </div>
      <div className="Events-body">
        {state.CalendarEventList.map((item) => (
          <div key={item.id} className="Events-body-item">
            <div className="Events-body-item-name">{item.name}</div>
            <div className="Events-body-item-time">{item.time}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Events;

